module.exports = __webpack_public_path__ + "img/28.65c9515c.png";